import { createAsyncThunk } from "@reduxjs/toolkit";

import { SentinelLoadingStatus } from "./types";
import { SentinelController } from "./controller";
import { EchoCommandInput, SubmitOnboardingRequestInput, GetTeamPackageListCommandInput, GetPackageDependencyListCommandInput } from "@amzn/dependencysentinel";

export const submitOnboardingRequest = createAsyncThunk(
  "sentinel/submitOnboardingRequest",
  async (payload: {
    sentinelController: SentinelController;
    onboardingRequestInput: SubmitOnboardingRequestInput;
  }) => {
    const response = await payload.sentinelController.submitOnboardingRequest(
      payload.onboardingRequestInput,
    );
    return {
      status: SentinelLoadingStatus.FINISHED,
      payload: response,
    };
  },
);


export const getOnboardedTeams = createAsyncThunk(
  "sentinel/getOnboardedTeams",
  async (payload: { sentinelController: SentinelController }) => {
    const response = await payload.sentinelController.getOnboardedTeams();
    return {
      status: SentinelLoadingStatus.FINISHED,
      payload: response,
    };
  }
);

export const getTeamPackageList = createAsyncThunk(
  "sentinel/getTeamPackages",
  async (payload: { 
    sentinelController: SentinelController;
    teamPackageListInput: GetTeamPackageListCommandInput;
  }) => {
    const response = await payload.sentinelController.getTeamPackageList(
      payload.teamPackageListInput
    );
    return {
      status: SentinelLoadingStatus.FINISHED,
      payload: response,
    };
  }
);

export const getPackageDependencyList = createAsyncThunk(
  "sentinel/getPackageDependencyList",
  async (payload: {
    sentinelController: SentinelController;
    packageDependencyListInput: GetPackageDependencyListCommandInput;
  }) => {
    const response = await payload.sentinelController.getPackageDependencyList(
      payload.packageDependencyListInput
    );
    return {
      status: SentinelLoadingStatus.FINISHED,
      payload: response,
    };
  }
);

export const submitPackageDryRunUpgrades = createAsyncThunk(
  "sentinel/submitPackageDryRunUpgrades",
  async (payload: {
    sentinelController: SentinelController;
    packageName: string;
  }) => {
    const response = await payload.sentinelController.submitPackageDryRunUpgrades(
      payload.packageName,
    );
    return {
      status: SentinelLoadingStatus.FINISHED,
      payload: response,
    };
  },
);

export const getPackageDryRunUpgradesResult = createAsyncThunk(
  "sentinel/getPackageDryRunUpgradesResult",
  async (payload: {
    sentinelController: SentinelController;
    requestId: string;
  }) => {
    const response = await payload.sentinelController.getPackageDryRunUpgradesResult(
      payload.requestId,
    );
    return {
      status: SentinelLoadingStatus.FINISHED,
      payload: response,
    };
  },
);

export const echo = createAsyncThunk(
  "sentinel/echo",
  async (payload: { sentinelController: SentinelController; message: string }) => {
    const response = await payload.sentinelController.echo(payload.message);
    return {
      status: SentinelLoadingStatus.FINISHED,
      payload: response,
    };
  },
);